<div class="switch-container" matTooltip="Mode clair / sombre">
  <mat-icon>light_mode</mat-icon>
  <mat-slide-toggle style="height: auto; margin: 0 7px;" [checked]="isDarkMode" color="accent"
    (change)="switchDarkMode()">
  </mat-slide-toggle>
  <mat-icon>dark_mode</mat-icon>
</div>
